import api from 'Application/api/api';

const deactivateEmployee = (id, cancelToken = null) =>
    api.post(`/employees/${id}/deactivate`, {}, { cancelToken });

export default deactivateEmployee;
